/*
 * This file is part of glowingblue/newvigation.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import IndexPageHero from './components/IndexPageHero';

// Make translation calls shorter
const t = app.translator.trans.bind(app.translator);

export default function () {
	override(IndexPage.prototype, 'hero', function (original) {
		let currentTag = this.currentTag();

		// Set a specific title & icon if not the default "all discussions"
		let title = '';
		let icon = '';
		let navItems = this.navItems();
		if (app.current.get('routeName') === 'following') {
			title = t('flarum-subscriptions.forum.index.following_link');
			icon = 'fas fa-star';
			navItems = null;
		}

		if (app.current.get('routeName') === 'byobuPrivate') {
			icon = app.forum.data.attributes['byobu.icon-badge'];
			title = t('fof-byobu.forum.hero.title');
		}

		if (app.current.get('routeName') === 'rankings') {
			icon = 'fas fa-trophy';
			title = t('fof-gamification.forum.nav.name');
		}

		if (app.current.get('routeName') === 'fof_user_directory') {
			icon = 'far fa-address-book';
			title = t('fof-user-directory.forum.hero.title');
		}

		return <IndexPageHero currentTag={currentTag} navItems={navItems} title={title} icon={icon} type="discussions" />;
	});
}
